import { Rating } from '../types';

export function ratingToCategory(rating: Rating['rating']): 'Best' | 'Good' | 'Fair' | 'Poor' {
  if (rating >= 4) return 'Best';
  if (rating >= 3) return 'Good';
  if (rating >= 2) return 'Fair';
  return 'Poor';
}
